import { useCallback, useMemo, useState } from 'react'

import {
  Table,
  TableHeader,
  TableCellHeadData,
  TableSortState,
} from 'shared/ui/common/Table'
import { TransactionRow } from 'modules/transactions/ui/TransactionRow'
import { TransactionFormatted } from 'modules/network/types'
import { TxType } from 'modules/transactions/types/TxType'

const TRANSACTIONS_TO_DISPLAY: Record<TxType, boolean> = {
  [TxType.NFCSMinted]: true,
  [TxType.BorrowSuccessful]: true,
  [TxType.InterestRateAnnualSet]: false,
  [TxType.LiquidityDeposited]: true,
  [TxType.LiquidityWithdrawn]: true,
  [TxType.ReserveRateSet]: false,
  [TxType.StakingRewardClaimed]: false,
  [TxType.AcceptedCollateralAdded]: false,
  [TxType.AcceptedCollateralRemoved]: false,
  [TxType.BalancingFundsRequested]: false,
  [TxType.Liquidated]: true,
  [TxType.CollateralDeposited]: true,
  [TxType.CollateralWithdrawn]: true,
  [TxType.LoanRepaid]: true,
  [TxType.ScoreUpdated]: true,
  [TxType.Unknown]: false,
}

const TABLE_HEAD: TableCellHeadData[] = [
  {
    sortField: '',
    title: (
      <>
        Type of
        <br />
        transaction
      </>
    ),
  },
  {
    sortField: 'timestamp',
    title: 'Time',
  },
  {
    sortField: '',
    title: 'Status',
  },
  {
    sortField: '',
    title: 'Amount',
  },
  {
    sortField: '',
    title: 'Gas cost',
  },
  {
    sortField: '',
    title: '',
  },
]

type Props = {
  data: TransactionFormatted[] | undefined
  onChangeSort: (sortState: TableSortState) => void
}

export function TransactionsTable({ data, onChangeSort }: Props) {
  const [sortState, setSortState] = useState<TableSortState>([
    TABLE_HEAD[1].sortField ?? null,
    1,
  ])
  // const [sortBy, sortDesc] = sortState

  const handleSort = useCallback(
    (s: TableSortState) => {
      onChangeSort(s)
      setSortState(s)
    },
    [onChangeSort],
  )

  const filteredData = useMemo(() => {
    if (!data) return
    return data.filter(t => TRANSACTIONS_TO_DISPLAY[t.transactionType])
  }, [data])

  return (
    <Table>
      <TableHeader
        sortState={sortState}
        headData={TABLE_HEAD}
        onChangeSort={handleSort}
        gridTemplateColumns="repeat(5, 2fr) repeat(1, 24px)"
      />
      {filteredData?.map((tx, i) => (
        <TransactionRow key={i} tx={tx} />
      ))}
    </Table>
  )
}
